// USAGE: Changes for production mode have to be done in environment.base.ts

import { base } from './environment.base';

export const environment = {
    ...base,
    mBookUrl: 'https://mbook.staging.sofamedia.at/',
    puppeteerDomain: 'https://digi-schule.staging.sofamedia.at',
    baseUrl: 'https://digi-schule.staging.sofamedia.at',
    endpointUrls: {
        ...base.endpointUrls
    }
};
